import { Flex, Skeleton } from "antd";
import { useMemo } from "react";

export const CreatePointFormSkeleton = () => {
    const widths = useMemo(
        () =>
            new Array(8)
                .fill(null)
                .map(() => Math.floor(80 + Math.random() * 100)),
        [],
    );

    return (
        <Flex vertical gap={16} style={{ height: "100%" }}>
            {widths.map((w, i) => (
                <Flex vertical key={i} gap={8}>
                    <Skeleton.Input
                        size="small"
                        style={{ width: w, height: 18 }}
                    />
                    <Skeleton.Input active block size="large" />
                </Flex>
            ))}

            <div style={{ marginTop: "auto" }}>
                <Skeleton.Button
                    active
                    block
                    size="large"
                    style={{ height: 50, borderRadius: 999 }}
                />
            </div>
        </Flex>
    );
};
